module.exports = __webpack_public_path__ + "img/grzx-50.c300f17b.png";